module.exports = __webpack_public_path__ + "static/media/hero_rainbow-flag.8390daac.png";